import { observer } from 'mobx-react-lite';
import LayoutPanel from './LayoutPanel';
import type { LayoutPanelProps, LayoutPanelValueProps } from './types';

export type { LayoutPanelProps, LayoutPanelValueProps };
export default observer(LayoutPanel); // MANUAL OVERRIDE
